import { InjectionToken } from '@angular/core';

import { ApplicationAuthorization } from '@core/app/scripts/services/application-authorization';
import { DataFeedAws } from '@shared/app/scripts/services/data-feed-aws';
import { Domain } from '@shared/app/scripts/services/domain';
import { LegacyProduct } from '@shared/app/scripts/services/legacy-product';
import { MOMENT } from '@new-core/app/scripts/vendor/moment';
import { PayNl } from '@shared/app/scripts/services/pay-nl';
import { FiscalPrinter } from '@shared/app/scripts/services/fiscal-printer';
import { Printer } from '@shared/app/scripts/services/printer';
import { Products } from '@wholesale/app/scripts/services/products';
import { ROUTE_DATE_FORMAT } from '@core/app/scripts/services/route-date-format';
import { Session } from '@shared/app/scripts/services/session';
import { SessionManager } from '@shared/app/scripts/services/session-manager';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

export const ROUTE_PARAMS = new InjectionToken<ng.route.IRouteParamsService>(
  '$routeParams',
);
export const ROUTE = new InjectionToken<ng.route.IRouteService>('$route');
export const TIMEOUT = new InjectionToken<ng.ITimeoutService>('$timeout');

function generateFactory(provide: any, name: string) {
  return {
    provide,
    useFactory: function ($injector: any) {
      return $injector.get(name);
    },
    deps: ['$injector'],
  };
}

export const AjsUpgradedProviders = [
  generateFactory(ApplicationAuthorization, 'applicationAuthorization'),
  generateFactory(Domain, 'domain'),
  generateFactory(LegacyProduct, 'legacyProduct'),
  generateFactory(MOMENT, 'moment'),
  generateFactory(PayNl, 'payNl'),
  generateFactory(FiscalPrinter, 'FiscalPrinter'),
  generateFactory(Printer, 'printer'),
  generateFactory(ROUTE_DATE_FORMAT, 'routeDateFormat'),
  generateFactory(Session, 'session'),
  generateFactory(SessionManager, 'sessionManager'),
  generateFactory(SettingsManager, 'settingsManager'),
  generateFactory(DataFeedAws, 'dataFeedAws'),
  generateFactory(Products, 'products'),
  {
    provide: ROUTE_PARAMS,
    useFactory: function ($injector: any) {
      return $injector.get('$routeParams');
    },
    deps: ['$injector'],
  },
  {
    provide: ROUTE,
    useFactory: function ($injector: any) {
      return $injector.get('$route');
    },
    deps: ['$injector'],
  },
  {
    provide: TIMEOUT,
    useFactory: function ($injector: any) {
      return $injector.get('$timeout');
    },
    deps: ['$injector'],
  },
];
